module.exports = __webpack_public_path__ + "img/diw_16_RecGroup.4425ba4c.png";